import { fetchEmployeeRecord } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type { EmployeeRecordT } from '@lotushealth/lotushealth_js_sdk/schemas';
import { APILevelT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchMyEmployeeRecord(signal?: AbortSignal): Promise<EmployeeRecordT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await fetchEmployeeRecord(APILevelT.app, config);
  return lotusHealthZod.fetchEmployeeRecordResponse.parse(response.data).employeeRecord;
}
